import { createAction, handleActions } from 'redux-actions';

import { DisabledChatbotStory, MiscChatbotStory } from '~/constants';

export const updateStories = createAction('app/UPDATE_STORIES');
export const resetStories = createAction('app/RESET_STORIES');

const defaultState = [
  {
    story_id: DisabledChatbotStory.KEY,
    name: DisabledChatbotStory.NAME,
    origin: DisabledChatbotStory.ORIGIN,
  },
  {
    story_id: MiscChatbotStory.KEY,
    name: MiscChatbotStory.NAME,
    origin: MiscChatbotStory.ORIGIN,
  },
];

export const stories = handleActions(
  {
    [updateStories]: (state, { payload }) => [...defaultState, ...payload],
    [resetStories]: () => defaultState,
  },
  defaultState
);
